(function () {
  window.PXUTheme.jsAnnouncementBar = {
    init: function ($section) {

      const data = window.PXUTheme.getSectionData($section);
      Object.assign(this, data);

      this.$el = $('#announcement-bar');
      if (!this.$el.length) return;

      const cookie = Cookies.get('announcement-bar');
      $('.announcement-bar__shadow').height(this.$el.outerHeight());

      if (this.show_close_icon === false) {
        Cookies.remove('announcement-bar');
        $('body').addClass('announcement-bar--visible');
      } else if (cookie !== 'dismiss') {
        $('body').addClass('announcement-bar--visible');
      } else {
        $('body').addClass('announcement-bar--hidden');
        this.disableSticky();
        return;
      }

      if (this.enable_sticky === true && !$('body').hasClass('template-index')) {
        this.enableSticky();
      } else {
        this.disableSticky();
      }

      if (this.show_close_icon === true) {
        $('body').addClass('has-announcement-bar-toggle');

        this.$el.on('click', '.js-close-announcement', () => {
          this.hide();
        });
      }
    },

    enableSticky: function () {
      if (!this.$el.parent().hasClass('announcement-sticky-wrapper')) {
        this.$el.parent().sticky({
          wrapperClassName: 'announcement-sticky-wrapper'
        });
      }
      this.resetHeader(this.$el.outerHeight());
    },

    disableSticky: function () {
      if (this.$el.parent().hasClass('announcement-sticky-wrapper')) {
        this.$el.parent().unstick();
      }
      this.resetHeader(0);
    },

    hide: function () {
      $('body').removeClass('announcement-bar--visible');
      this.disableSticky();
      Cookies.set('announcement-bar', 'dismiss', { expires: 30 });
    },

    resetHeader: function (offset) {
      if (!window.PXUTheme.jsHeader) return;

      if (window.PXUTheme.jsHeader.enable_sticky === true && isScreenSizeLarge()) {
        if (window.PXUTheme.theme_settings.header_layout !== 'vertical') {
          window.PXUTheme.jsHeader.disableSticky();
          window.PXUTheme.jsHeader.enableSticky(offset);
        }
      } else if (window.PXUTheme.jsHeader.enable_sticky === true && !isScreenSizeLarge()) {
        window.PXUTheme.mobileMenu.disableSticky();
        window.PXUTheme.mobileMenu.enableSticky(offset);
      }
    },
 getAnnouncementHeight() {
    const announcementHeight = $('.announcement-container').outerHeight() || 0;
    console.log('outer height: ', announcementHeight);

    return announcementHeight;
  },
    unload: function () {
      this.$el.off();
      this.disableSticky();
    }
  };
})();
